













import {Component, Prop} from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import LocationWorkerType from '@/models/LocationWorkers/LocationWorkerType';


@Component({
  name: 'LocationWorkerType',
})
export default class extends GiganautVue {

    LocationWorkerType = LocationWorkerType;

	@Prop({required: true})
	type: LocationWorkerType;
}
